var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "section" },
    [
      _c("b-loading", {
        model: {
          value: _vm.isLoading,
          callback: function ($$v) {
            _vm.isLoading = $$v
          },
          expression: "isLoading",
        },
      }),
      _c(
        "b-field",
        { attrs: { label: _vm.$t("global.materials") } },
        _vm._l(_vm.material, function (el, i) {
          return _c(
            "b-radio-button",
            {
              key: i,
              attrs: { "native-value": el, type: "is-primary" },
              model: {
                value: _vm.selectedMaterial,
                callback: function ($$v) {
                  _vm.selectedMaterial = $$v
                },
                expression: "selectedMaterial",
              },
            },
            [_c("span", [_vm._v(_vm._s(el))])]
          )
        }),
        1
      ),
      _c(
        "b-field",
        { attrs: { label: _vm.$t("pages.new_crates.production_plant") } },
        [
          _c("b-taginput", {
            attrs: { data: _vm.plants, autocomplete: "", "open-on-focus": "" },
            model: {
              value: _vm.selectedPlant,
              callback: function ($$v) {
                _vm.selectedPlant = $$v
              },
              expression: "selectedPlant",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d-flex-row d-flex-space-evenly timelines" },
        _vm._l(_vm.selectedPlant, function (el, i) {
          return _c("Timeline", {
            key: i,
            staticClass: "d-flex-column",
            attrs: {
              plant: el,
              material: _vm.selectedMaterial,
              "all-data": _vm.data,
            },
            on: { "to-save": _vm.toSave },
          })
        }),
        1
      ),
      _vm.selectedMaterial
        ? _c(
            "div",
            [
              _c("input", {
                attrs: { id: "fileUpload", type: "file", hidden: "" },
                on: { change: _vm.loadTextFromFile },
              }),
              _c(
                "b-button",
                { staticClass: "btn", on: { click: _vm.chooseFiles } },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("pages.new_crates.upload_csv")) + " "
                  ),
                ]
              ),
              _c(
                "b-button",
                {
                  staticClass: "btn",
                  attrs: { type: "is-primary" },
                  on: { click: _vm.getTemplate },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("pages.new_crates.get_csv_template")) +
                      " "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-button",
        {
          staticClass: "btn",
          attrs: { type: "is-green" },
          on: { click: _vm.save },
        },
        [_vm._v(" " + _vm._s(_vm.$t("global.save")) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }